export default class AuswertungenRowVariant {
  get(row) {
    return row.included ? '' : 'summary'
  }
}
